Monet.Grid = Monet.Grid || {};
Monet.Grid.ActionsModules = Monet.Grid.ActionsModules || {};

Monet.Grid.ActionsModules.IntegrationLogRetry = function () {
  this.entity = null;
  this.selector = null;
  this.screenName = null;
  this.valueBtn = null;
  this.id = "integrationLogRetrySelected";
  this.className = "";
  this.disabled = false;
  this.label = null;

  this.setEntity = function (entity) {
    this.entity = entity;
  };

  this.setLabel = function (label) {
    this.label = label;
  };

  this.setSelector = function (selector) {
    this.selector = selector;
  };

  this.setScreenName = function (screenName) {
    this.screenName = screenName;
  };

  this.setValueBtn = function () {
    this.valueBtn = Monet.I18n.getResourcesByKey('IntegrationLog.screen.retryButton');
  };

  this.setBtnSelector = function (btnSelector) {
    this.btnSelector = btnSelector;
  };

  this.setId = function (id) {
    this.id = id;
  };

  this.setClassName = function (className) {
    this.className = className;
  };

  this.setDisabled = function (disabled) {
    this.disabled = disabled;
  };

  this.checkElementAndWriteHTML = function (selector, html) {
    if (selector !== null) {
      const buttonsContainerSelector = `${selector} .buttonsContainer`;
      const buttonsContainer = $(buttonsContainerSelector);

      if(!buttonsContainer.length ) {
        const div = document.createElement('div');
        div.className = 'buttonsContainer';
        $(selector).append(div);
      }

      $(buttonsContainerSelector).append(html);
    }
  };

  this.handleButtonDisable = function (entity, enable) {
    const selector = `#${entity} #${this.id}`;

    const button = document.querySelector(selector);

    if (button && enable) {
      button.removeAttribute('disabled');
    } else if(button && !enable) {
      button.setAttribute('disabled', 'true');
    }
  };

  this.retrySelectedItems = function () {
    const selectedItems = App.Forms[this.entity].table.getItemsSelected();
    const logsIdsToRetry = selectedItems.map(item => item.get('id'));
    
    const { integrations: { actionCreators } } = window.actions;
    
    window.globalStore.dispatch(actionCreators.setRetryLogsState({ 
      logsToRetry: logsIdsToRetry, 
      isRetrying: false, 
      error: null 
    }));
    window.globalStore.dispatch(actionCreators.toggleRetryIntegrationLogsConfirmModal());
  };

  this.createBtn = function () {
    try {
      const templateHTML = `
        <div class="eventCheckBox gridActionDiv">
          <div class="spinner"></div>
          <input 
            type="button" 
            id="${this.id}" 
            class="button ${this.className}" 
            value="${this.valueBtn}"
            ${this.disabled && 'disabled'}
          />
        </div>`;

      this.checkElementAndWriteHTML(this.selector, templateHTML);
    } catch(e) {
      new Monet.Exception
        .ReturnError(this, "Error on create button", e)
        .console();
    }
  };

  this.addEventListeners = function () {
    const button = document.querySelector(`input#${this.id}`);

    const onClickFunction = () => {
      this.retrySelectedItems();
    };

    if (button) {
      button.removeEventListener('click', onClickFunction);
      button.addEventListener('click', onClickFunction);
    }
  };

  this.init = function () {
    this.setDisabled(true);
    this.createBtn();
    this.addEventListeners();
  };

  return this;
};
